/**
 * Sort key for Facturation archives: newest-first, robust to FR DD/MM/YYYY and ISO timestamps.
 * Used by DocumentsContext loads and Archives table ordering so "one-click save" order matches GET /archives after refresh.
 */
export function archiveDocumentSortTime(doc) {
  if (!doc) return 0;

  const isoish = doc.updated_at || doc.updatedAt || doc.created_at || doc.createdAt;
  if (isoish != null && String(isoish).trim() !== '') {
    const t = Date.parse(String(isoish));
    if (Number.isFinite(t)) return t;
  }

  const rawDate = doc.date;
  if (rawDate != null && String(rawDate).trim() !== '') {
    const s = String(rawDate).trim();
    const dm = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(s);
    if (dm) {
      const [, dd, mm, yyyy] = dm;
      const iso = `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
      const t = Date.parse(iso);
      if (Number.isFinite(t)) return t;
    }
    const tp = Date.parse(s);
    if (Number.isFinite(tp)) return tp;
  }

  return 0;
}

export function compareDocumentsNewestFirst(a, b) {
  const diff = archiveDocumentSortTime(b) - archiveDocumentSortTime(a);
  if (diff !== 0) return diff;
  const na = String(a?.number ?? a?.id ?? '');
  const nb = String(b?.number ?? b?.id ?? '');
  return nb.localeCompare(na);
}

